module.exports = __webpack_public_path__ + "logo.svg?6a61060b384f17d8e13f200236df0e4c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 168
// module chunks = 0